export default __webpack_public_path__ + "static/media/photo-test.8524633d.jpg";